import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { useProductApiV1 } from '../../../clients/quipli-service/product/product-api-v1';
import { Field } from '../../../components/field/field';

export const ProductDepreciationConfig = ({ productId }: { productId?: number }) => {
  const { getProductDepreciationPercentage, upsertProductDepreciationPercentage } = useProductApiV1();

  const [isLoading, setIsLoading] = useState(false);
  const [percentage, setPercentage] = useState<number>();

  const handleOnChange = useCallback(
    debounce(async (_percentage?: number) => {
      if (_percentage && _percentage != percentage && !isLoading && productId) {
        setIsLoading(true);

        const result = await upsertProductDepreciationPercentage(productId, _percentage);
        console.log(result);
        setPercentage(result.depreciationPercentage);

        setIsLoading(false);
      }
    }, 500),
    [productId],
  );

  /*const handleOnDelete = async () => {
    await deleteProductDepreciationPercentage(productId);
    setPercentage(undefined);
  };*/

  const fetchProductDepreciationPercentage = async () => {
    if (!productId) return;
    setIsLoading(true);
    const result = await getProductDepreciationPercentage(productId);

    setPercentage(result?.depreciationPercentage);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchProductDepreciationPercentage();
  }, [productId]);

  return (
    <div className="flex flex-col max-w-sm md:max-w-md">
      <div className="flex items-center gap-2">
        <Field
          label="Depreciation Percentage"
          labelType="text-xs"
          type="number"
          value={percentage}
          onChange={(newValue: number) => handleOnChange(newValue || undefined)}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};
